import dynamic from 'next/dynamic';
import { useMst } from '@models/Root';
import { observer } from 'mobx-react';
import { ReactourStep } from 'reactour';
import { Button } from 'antd';
import styled from 'styled-components';

const TourButton = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom: 20px;
  margin-right: 20px;
  background-color: #fff;
  padding: 8px;
  border-radius: 65px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.19);
  -webkit-transition: transform 200ms ease-out;
  -moz-transition: transform 200ms ease-out;
  -o-transition: transform 200ms ease-out;
  transition: transform 200ms ease-out;
  cursor: pointer;
  z-index: 10000000000;

  img {
    height: 33px;
  }

  &:hover {
    transform: scale(1.2);
  }
`;

const Tour = dynamic(() => import('reactour'), {
  ssr: false,
});

interface AppToursPros {
  steps: ReactourStep[];
}

export const AppTours = observer(({ steps }: AppToursPros) => {
  const { tourOpen, setTourOpen } = useMst();

  return (
    <>
      <Tour
        accentColor="#F7931C"
        steps={steps}
        isOpen={tourOpen}
        onRequestClose={() => {
          setTourOpen(false);
        }}
        lastStepNextButton={<Button size="small">Done {Math.random() < 0.5 ? '🎉' : '🥳'}</Button>}
      />

      <TourButton
        id="help-tour"
        onClick={() => {
          setTourOpen(!tourOpen);
        }}
      >
        <img src="/images/bots/bot-face.svg" alt="Help" />
      </TourButton>
    </>
  );
});
